import FormProveedores from '../componentes/FormProveedores.vue'
import ListaProveedores from '../componentes/ListaProveedores.vue'


const routes = [
    ...route('/guardar-proveedor', FormProveedores, {
        Auth: true,
        //req_admin: true
     }),
     ...route('/lista-proveedores', ListaProveedores, {
       Auth: true,
       //req_admin: true
    }),
]

function route(path, component = Default, meta = {}) {
	return [{
		path,
		component,
		meta
	}]
}

export default routes